import styled, { css } from 'styled-components'

export const OptionTitle = styled.div`
  width: 100%;
  margin: ${({ isBusinessesPage }) => isBusinessesPage ? '0' : '0 auto'};
  padding: ${({ isBusinessesPage }) => isBusinessesPage ? '10px 20px 0' : '0 15px'};
  h1 {
    text-transform: capitalize;
    font-size: 18px;
    margin: 0;
  }

  @media (min-width: 768px){
    padding: ${({ isBusinessesPage }) => isBusinessesPage ? '10px 20px 0' : '10px 0'};
    width: 100%;
  }
`

export const OrdersContainer = styled.div`
  ${({ activeOrders }) => activeOrders && css`
    padding: 0 10px;
    text-align: center;
    display: flex;
    justify-content: ${({ ordersLength }) => !ordersLength ? 'flex-start' : 'center'};
    width: 100%;
    margin: auto 0px auto auto;
    box-sizing: border-box;
    ${props => props.theme?.rtl && css`
      margin: auto auto auto 0px;
    `}
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }

    ${({ isSkeleton }) => !isSkeleton && css`
      ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      }
      ${({ ordersLength, isBusinessesPage }) => !ordersLength && !isBusinessesPage && css`
        > div {
          margin-left: -10px;
          ${props => props.theme?.rtl && css`
            margin-left: 0;
            margin-right: -10px;
          `}
        }
        > div:first-child{
          margin-left: -15px;
          ${props => props.theme?.rtl && css`
            margin-left: 0;
            margin-right: -15px;
          `}
        }
      `}
    `}

    @media (min-width: 768px) {
      width: 100%;
      justify-content: flex-start;
      ${({ isSkeleton, ordersLength }) => !isSkeleton && !ordersLength && css`
        > div:first-child {
          ${({ isBusinessesPage }) => !isBusinessesPage && css`
            margin-left: -10px;
            ${props => props.theme?.rtl && css`
              margin-left: 0;
              margin-right: -10px;
            `}
          `}
        }
      `}
    }
  `}

  ${({ activeOrders }) => !activeOrders && css`
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    margin: 0 auto;

    p {
      margin-block-end: 0;
      margin-block-start: 0;
    }

    @media(min-width: 480px){
      width: 100%;
      padding: 0;
      div:last-child {
        border-top: none;
      }
    }
  `}
`

export const SkeletonOrder = styled.div`
  display: flex;

  ${({ activeOrders }) => activeOrders && css`
    width: auto;
    text-align: center;
    margin-left: 10px;

    ${props => props.theme?.rtl && css`
      margin-right: 10px;
      margin-left: 0;
    `}
  `}

  ${({ activeOrders }) => !activeOrders && css`
    width: 100%;
    flex-direction: column;
    margin: 10px 0;
    > * {
      margin: 20px 0;
    }
  `}
`

export const SkeletonCard = styled.div`
  margin: 10px 5px 10px 5px;
`

export const SkeletonContent = styled.div`
  display: flex;
  width: 100%;

  ${({ activeOrders }) => activeOrders && css`
    > * {
      margin: 5px;
    }
  `}

  ${({ activeOrders }) => !activeOrders && css`
    justify-content: space-between;
  `}
`

export const SkeletonText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;

  ${props => props.theme?.rtl && css`
    text-align: right;
  `}
`

export const SkeletonButton = styled.div`
    span{
      border-radius: 24px;
      width: 270px;
      height: 36px;
    }
  @media(min-width: 480px){
    span{
      width: 360px;
    }
  }
`

export const SkeletonInformation = styled.div`
  display: flex;

  > *{
    margin: 5px;
  }
`

export const SkeletonReorder = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: center;
  align-items: center;
  margin-right: 25px;

  ${props => props.theme?.rtl && css`
    margin-left: 25px;
    margin-right: 0;
  `}

  span:first-child span{
    width: 40px;
  }

  span:last-child{
    width: 75px;
    height: 30px;
  }

  @media(min-width: 480px){
    ${props => props.theme?.rtl
? css`
      margin-left: 0;
    `
: css`
      margin-right: 0;
    `}
    span:first-child span{
      width: 80px;
    }
    span:last-child{
      width: 150px;
    }
  }
`

export const ImageNotFound = styled.div`

  margin: 0 auto;
  img {
    width: 100%;
  }
`

export const BusinessInformation = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 110px;
  justify-content: space-between;
  flex: 1;
  padding-left: 10px;
  font-size: 0.9em;

  ${props => props.theme?.rtl && css`
    padding-right: 10px;
    padding-left: 0;
  `}
  .orders-detail {
    display: flex;
    align-items: center;

    svg {
      background: transparent;
      border: none;
      opacity: 1;
      color: #909BA9;
      width: 15px;
      min-width: 15px;
    }
    .order-number {
      white-space: pre-wrap;
      color: ${props => props.theme.colors.darkGray};
    }
  }
  h2 {
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 16px;
    margin-block-end: 0;
    margin-block-start: 0;
    color: ${({ theme }) => theme?.colors?.headingColor};
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }
  p {
    margin-block-end: 0.1em;
    margin-block-start: 0.1em;
    white-space: nowrap;
    font-size: 0.9em;
    ${({ activeOrders }) => activeOrders && css`
      font-size: 0.8em;
    `}
  }

  p[name='view_order'] {
    color: ${props => props.theme.colors.primary};
    cursor: pointer;
    text-decoration: none;
    width: fit-content;
  }

  @media (min-width: 480px) {
    h2 {
    font-size: 16px;
    margin-block-end: 0.1em;
    margin-block-start: 0.1em;
    }
    p{
      ${({ activeOrders }) => activeOrders && css`
        font-size: 0.9em;
      `}
    }
  }

  @media (min-width: 768px){
    font-size: 0.9em;
    p {
      font-size: 14px;
    }
  }
`

export const NoOrdersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-top: 0px;
    margin-bottom: 25px;
  }

  button {
    height: 44px;
  }
`

export const BusinessListWrapper = styled.div`
  overflow: auto hidden;
  width: 100%;
`

export const BusinessList = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  ${({ noResults }) => noResults && css`
    justify-content: center;
  `}
  @media (min-width: 480px){
    flex-direction: row;
  }
  #searchlist {
    > div {
      width: calc(100vw - 40px);
      min-width: calc(100vw - 40px);

      @media (min-width: 681px) {
        width: calc(50vw - 40px);
        min-width: calc(50vw - 40px);
      }
      @media (min-width: 993px) {
        width: calc(33vw - 40px);
        min-width: calc(33vw - 40px);
      }
      @media (min-width: 1200px) {
        width: calc(25vw - 40px);
        min-width: calc(25vw - 40px);
      }
    }
  }
`

export const BusinessControllerSkeleton = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  > div {
    flex: 1;
  }
`

export const ProductsListing = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 45px;
  width: 100%;
  .product-card {
    width: ${({ horizontal }) => horizontal ? '270px' : 'auto'} !important;
    max-width: ${({ horizontal }) => horizontal ? '270px' : 'none'} !important;
  }
`
